import {
  ChatBubbleOvalLeftEllipsisIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { cx } from "../utils/cx";

export function TypeSquircle({ type, read }) {
  const base =
    "inline-flex items-center justify-center h-6 w-6 rounded-xl ring-1 ring-black/5 shadow-sm";
  const icon = "h-3.5 w-3.5";
  const muted = read ? "opacity-60" : "";

  if (type === "like" || type === "comment_like") {
    return (
      <span className={cx(base, "bg-rose-50", muted)}>
        <HeartSolid
          className={cx(icon, read ? "text-rose-400" : "text-rose-500")}
        />
      </span>
    );
  }
  if (type === "comment") {
    return (
      <span className={cx(base, "bg-primary-50", muted)}>
        <ChatBubbleOvalLeftEllipsisIcon
          className={cx(
            icon,
            read ? "text-text-primary-500" : "text-text-inverse"
          )}
        />
      </span>
    );
  }
  if (type === "nearby_note") {
    return (
      <span className={cx(base, "bg-emerald-50", muted)}>
        <MapPinIcon
          className={cx(icon, read ? "text-primary-400" : "text-primary-500")}
        />
      </span>
    );
  }
  return <span className={cx(base, "bg-surface", muted)} />;
}
